<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M64.8692 40.7548C51.7893 40.6317 32.19 42.7028 32.6192 52.133C33.4215 69.803 108.863 64.7912 88.0137 57.2754C69.1122 50.4612 29.0217 59.3801 25.0586 72.0458"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M89.7031 103.229L89.7479 106.744C89.7554 108.408 91.1137 109.756 92.7781 109.748L96.2412 109.733C97.9056 109.726 99.2527 108.367 99.2453 106.703L99.2005 98.5789"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M27.1738 100.292L27.2186 107.028C27.2223 107.942 27.6291 108.755 28.2747 109.304C28.8046 109.759 29.495 110.035 30.2525 110.032L33.7194 110.017C34.4284 110.017 35.074 109.77 35.5853 109.36C36.2831 108.804 36.7272 107.946 36.7235 106.987L36.6787 103.628"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M100.668 92.037C101.038 86.2117 101.086 82.8755 100.545 77.6174C100.183 75.9866 100.183 74.1729 98.5522 73.087C97.6454 72.5422 96.7386 72.001 96.1975 71.0942C96.0146 70.7322 95.8355 70.1874 95.6526 69.8254C94.201 62.9366 92.2082 56.9545 90.2154 50.4314C89.4915 47.8938 88.0846 46.0167 85.894 44.4045C85.8157 44.3448 85.685 44.2665 85.5246 44.1732C84.7297 43.7179 83.8677 43.3932 82.972 43.1955C81.6734 42.9081 79.3037 42.4304 77.4863 42.3707"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M79.6573 78.9533C80.176 79.2668 80.4634 79.8564 80.3962 80.4573C80.3701 80.6961 80.3402 80.9648 80.3066 81.2372C80.3066 81.2521 80.3029 81.267 80.3029 81.2782C80.2171 81.9947 80.1313 82.7486 80.0715 83.1553C80.0417 83.3867 79.7096 83.7449 79.202 84.1592C78.6759 84.5958 77.9594 85.0884 77.2018 85.5549C75.6979 86.4841 74.0298 87.3051 73.373 87.3051L63.1852 87.3536C63.1852 87.3536 63.1554 87.3536 63.1143 87.3536L52.9303 87.4021C52.2735 87.4021 50.598 86.6035 49.0829 85.6855C48.3216 85.2265 47.6013 84.7413 47.0677 84.3084C46.5564 83.8979 46.2243 83.5434 46.1907 83.3121C46.1273 82.9053 46.034 82.1552 45.9444 81.4387L45.937 81.3939C45.9034 81.1215 45.8698 80.8565 45.8399 80.614C45.7653 80.0132 46.0489 79.4235 46.5639 79.1026C46.5676 79.1026 46.5751 79.0951 46.5788 79.0951C46.605 79.0765 46.6311 79.0653 46.6572 79.0466C46.6945 79.0242 46.7356 78.9981 46.7729 78.9795C46.8401 78.9347 46.9035 78.8974 46.9707 78.86C47.6088 78.4794 48.3216 78.0876 48.6686 78.0204C49.3627 77.8861 62.3419 77.9495 63.1031 77.9532C63.8607 77.942 76.8361 77.7592 77.5339 77.8861C77.8847 77.9495 78.6012 78.3339 79.2431 78.7108C79.3103 78.7481 79.3774 78.7854 79.4446 78.8302C79.4857 78.8489 79.523 78.875 79.5603 78.8974C79.5827 78.916 79.6125 78.9272 79.6349 78.9459C79.6387 78.9459 79.6461 78.9533 79.6499 78.9533H79.6573Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M92.9425 73.2924C92.9425 73.2924 90.222 75.1433 87.2851 76.6099C84.3482 78.0728 82.9861 78.278 82.7697 79.0356C82.5532 79.7931 84.9378 81.1963 85.8185 81.2373C86.6992 81.2784 93.9725 80.95 95.3271 79.6662C96.6855 78.3862 97.3161 74.5201 96.9168 73.8223"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M32.8099 73.0981C32.8099 73.0981 35.9669 75.3969 38.9188 76.8299C41.8706 78.2667 43.2327 78.457 43.4566 79.2145C43.6768 79.9721 41.3071 81.3939 40.4264 81.4424C39.5495 81.4909 32.2725 81.2297 30.9029 79.9609C30.6977 79.7706 30.5111 79.5243 30.3357 79.2406C29.358 77.6136 28.9251 74.7289 29.2609 74.1281"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M32.3778 90.0069L41.6736 93.1416C42.3901 93.3842 42.6849 94.2387 42.267 94.8731L41.6363 95.8322C41.4049 96.1867 40.9982 96.3845 40.5765 96.3472L31.7359 95.6046C31.415 95.5785 31.1202 95.418 30.9224 95.1642L29.8215 93.7536C29.5155 93.3618 29.4931 92.8207 29.7693 92.4064L31.0493 90.4696C31.3366 90.033 31.8852 89.8427 32.3815 90.0106L32.3778 90.0069Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M30.0914 69.1387C30.084 70.0605 23.8706 69.0343 23.4302 68.8178C23.2623 68.7357 22.9973 68.3588 22.7809 67.8774C22.6727 67.6311 22.5794 67.3624 22.5197 67.09C22.3853 66.4929 22.4077 65.8809 22.7995 65.5264C23.7176 64.6867 28.5465 63.5896 29.3861 63.9553C30.2221 64.3247 30.0914 69.1387 30.0914 69.1387Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M29.7748 67.0752L32.2789 66.9707L31.4765 69.5083L28.9277 69.5195L29.7748 67.0752Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.9392 92.2236C76.6742 91.6526 74.6031 90.4323 73.8082 90.436C73.0544 90.436 64.031 90.4808 63.1951 90.4846C63.1951 90.4846 63.1689 90.4846 63.1279 90.4846C62.292 90.4883 53.2685 90.5293 52.5147 90.5331C51.7236 90.5331 49.6636 91.7758 49.4024 92.3504C49.1412 92.9214 50.9548 95.3321 51.9251 96.03C52.8618 96.7054 62.5457 96.5188 63.1913 96.5076C63.8332 96.5151 73.5209 96.6121 74.4501 95.9292C75.4129 95.2202 77.2041 92.7945 76.9392 92.2273V92.2236Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M93.9458 89.7232L84.6798 92.9438C83.9633 93.1938 83.6797 94.0521 84.1014 94.6791L84.7432 95.6307C84.9783 95.9814 85.3888 96.1755 85.8105 96.1344L94.6437 95.3097C94.9646 95.2799 95.2557 95.1194 95.4534 94.8619L96.5431 93.4401C96.8454 93.0483 96.8603 92.5034 96.5842 92.0929L95.2893 90.1673C94.9982 89.7307 94.4459 89.5479 93.9533 89.7232H93.9458Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M96.0426 68.8365C96.0575 69.7583 102.26 68.6761 102.7 68.4559C102.868 68.3701 103.129 67.9932 103.338 67.508C103.443 67.2617 103.532 66.993 103.592 66.7169C103.723 66.1161 103.693 65.5041 103.297 65.1533C102.372 64.3211 97.5316 63.2687 96.6957 63.6419C95.8635 64.0188 96.0389 68.8328 96.0389 68.8328L96.0426 68.8365Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M96.3417 66.7691L93.834 66.687L94.6587 69.2172L97.2112 69.2022L96.3417 66.7691Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M74.1387 45.9384L78.7362 46.2742C82.8934 46.6399 84.8265 48.5917 85.8005 52.0025L88.8083 62.5186C89.0956 63.5225 88.9911 64.5338 88.6105 65.3809C87.9239 66.9035 85.8751 67.5454 84.3339 67.5901"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.6602 93.2982L76.7647 93.1116C77.7125 91.4174 79.4291 90.283 81.3622 90.0852C83.5416 89.865 85.9187 89.5067 88.4488 88.9507C93.0725 87.9319 96.6961 86.7527 99.8196 85.3794"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M49.6536 93.2982L49.5491 93.1116C48.6012 91.4174 46.8846 90.283 44.9515 90.0852C42.7722 89.865 40.395 89.5067 37.8649 88.9507C33.2412 87.9319 29.6176 86.7527 26.4941 85.3794"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.8264 13.651C82.4827 13.3189 79.5011 15.7594 79.1689 19.1031C78.8368 22.4468 81.2774 25.4285 84.6211 25.7606C87.9647 26.0927 90.9464 23.6521 91.2785 20.3085C91.6107 16.9648 89.1701 13.9831 85.8264 13.651Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.162 38.1913L72.5048 44.8786C72.4339 45.0055 72.3294 45.1062 72.1988 45.1734L71.7995 45.3749C71.5756 45.4869 71.4301 45.7033 71.4077 45.9534L71.3368 46.7967C71.3256 46.9236 71.2808 47.0468 71.2062 47.1475L70.0605 48.7597C69.9747 48.8791 69.8553 48.9686 69.7172 49.0209L69.5232 49.0918C69.2022 49.2112 69.0082 49.5321 69.0567 49.8717L69.0679 49.9576C69.094 50.1441 69.0492 50.3307 68.941 50.4837L67.0751 53.0512C66.8587 53.3497 66.4444 53.4393 66.1086 53.2565L65.657 53.0139C65.3212 52.8348 65.1719 52.4392 65.2988 52.0959L66.422 49.1291C66.4892 48.9574 66.6198 48.8156 66.7915 48.7335L66.8699 48.6962C67.1796 48.5507 67.3438 48.2148 67.2654 47.879L67.2169 47.6774C67.1833 47.5319 67.1908 47.3826 67.2468 47.2483L67.967 45.4085C68.0118 45.2891 68.0902 45.1846 68.1909 45.1062L68.8552 44.5838C69.0492 44.4308 69.1537 44.1882 69.1239 43.9419L69.0716 43.4978C69.0567 43.3523 69.0828 43.2068 69.15 43.0799L72.7362 36.3552"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M83.8529 25.8912L78.8038 23.1632C77.1954 22.2937 75.0459 22.8908 73.6763 24.6336C72.3926 26.2681 71.0865 28.6863 70.426 30.6529C69.7207 32.7539 70.3998 34.8773 72.0082 35.7468L77.0573 38.4747C78.6657 39.3442 80.8152 38.7472 82.1848 37.0044C83.4685 35.3699 84.7746 32.9517 85.4352 30.9851C86.1405 28.8841 85.4613 26.7607 83.8529 25.8912Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M82.5181 31.3807C82.9734 30.026 82.5367 28.6602 81.4993 28.1042L78.2489 26.3502C77.2115 25.7905 75.8307 26.1748 74.95 27.2981C74.1216 28.3505 73.476 29.5484 73.0506 30.8172C72.5953 32.1718 73.0319 33.5376 74.0693 34.0937L77.3197 35.8476C78.3572 36.4074 79.7379 36.023 80.6186 34.8997C81.4471 33.8474 82.0927 32.6495 82.5181 31.3807Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M104.412 31.8322C102.762 29.3207 98.635 24.0515 97.2916 22.82C95.6534 21.3235 93.4404 21.0847 91.9925 22.208L87.4584 25.7196C86.0104 26.8391 85.6895 29.0446 86.7269 31.0038C87.7009 32.8398 92.8471 39.4861 94.3808 40.8855C96.0191 42.382 98.232 42.6208 99.6799 41.4975L104.214 37.9859C105.016 37.3627 105.475 36.4074 105.546 35.3438C105.576 34.9184 105.539 34.4743 105.442 34.0302"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M96.5641 25.7756C95.5118 24.8128 94.0862 24.6598 93.1533 25.38L90.235 27.6415C89.3021 28.3617 89.0969 29.7798 89.7648 31.0411C90.3918 32.2241 94.1124 37.0269 95.1013 37.93C96.1536 38.8928 97.5792 39.0458 98.5121 38.3256L101.43 36.0641C102.363 35.3439 102.569 33.9258 101.901 32.6644C101.274 31.4815 97.5531 26.6787 96.5679 25.7756H96.5641Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.9434 28.802L81.7017 33.0264"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M91.0566 32.7092L97.8858 27.4661"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M93.9648 36.2245L100.772 31.0597"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.3231 45.7368C59.7143 45.6659 54.6652 46.0876 50.3027 46.7145"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M25.0586 72.0421C22.4688 80.3229 21.3268 95.1232 28.8874 99.7991C37.1235 104.893 83.4684 102.109 83.4684 102.109C83.4684 102.109 100.123 102.005 100.691 91.9362"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M25.1582 45.4083C26.2964 43.7626 28.1399 41.5198 30.9313 39.5047C35.2265 36.4073 39.5181 35.4706 41.8393 35.1422"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
